import _ from 'lodash';
import Cookie from 'js-cookie';
import Vue from 'vue';
import Router from 'vue-router';

// 公共组件
import Index from './../views/Index.vue'; // 首页
import Products from './../views/Products.vue'; // 产品列表
import AboutUs from './../views/AboutUs.vue'; // 关于我们
import Login from '../components/user/Login.vue';
import Register from '../components/user/Register.vue';
import ForgetPassword from '../components/user/ForgetPassword.vue';

// 产品详情页
import ProductDetails from './../views/ProductDetails.vue'; // 信贷产品详情页
import Bill from '../components/products/Bill.vue'; // 电票详情页
import Lease from '../components/products/Lease.vue'; // 票据
import Factoring from '../components/products/Factoring.vue'; // 保理产品详情页

// 会员中心模块
import User from './../views/User.vue';
import PersonalCenter from './../views/PersonalCenter.vue';
import PersonInfo from '../components/personalCenter/PersonInfo.vue';
import UpdatePassword from '../components/personalCenter/UpdatePassword.vue'; // 修改密码
import RealNameAuth from '../components/personalCenter/RealNameAuth.vue'; // 实名认证
import BankcardInfo from '../components/personalCenter/BankcardInfo.vue'; // 银行卡信息
import TransferAdviceList from '../components/personalCenter/TransferAdviceList.vue'; // 转让通知列表
import TransferAdviceDetail from '../components/personalCenter/TransferAdviceDetail.vue'; // 转让通知书详情

import RepoNoticeList from '../components/personalCenter/RepoNoticeList.vue'; // 回购通知书列表
import RepoNoticeDetail from '../components/personalCenter/RepoNoticeDetail.vue'; // 回购通知书详情

import ProjectContractList from '../components/personalCenter/ProjectContractList.vue'; // 保理主合同列表
import blLoanContractList from '../components/personalCenter/blLoanContractList.vue'; // 单笔业务合同

// 标准版小贷
// import WholeRepay from '../components/personalCenter/WholeRepay.vue'

import ApplyLoan from './../views/ApplyLoan.vue';
import placeholders from '../scripts/placeholders';
import bankCardSign from '../components/personalCenter/bankCardSign.vue';

// 站内信
import message from '../components/personalCenter/message.vue';
import messagedetails from '../components/personalCenter/messagedetails.vue';

// 工单咨询
import workOrder from '../components/personalCenter/workOrder.vue';
import workOrderDetails from '../components/personalCenter/workOrderDetails.vue';

/*
 * 下面信贷模块
 * */
// 融资申请
import Step1_xd from '../components/applyLoan/Step1_bak.vue';
import Step2_xd from '../components/applyLoan/Step2_bak.vue';
import Step3_xd from '../components/applyLoan/Step3_bak.vue';
import Step4_xd from '../components/applyLoan/Step4_bak.vue';
import Step5_xd from '../components/applyLoan/Step5_bak.vue';
// 我的信贷
import MyLoan from '../components/personalCenter/MyLoan.vue'; // 我的信贷
import LoanLists from '../components/personalCenter/LoanLists.vue'; // 我的信贷列表
import LoanDetail from '../components/personalCenter/LoanDetail.vue'; // 信贷详情
import MyInfo from '../components/personalCenter/MyInfo.vue';
import RepaymentInfo from '../components/personalCenter/RepaymentInfo.vue'; // 还款计划详情
import Prepayment from '../components/personalCenter/Prepayment.vue';
import FileUploading from '../components/personalCenter/FileUploading.vue';

/*
 * 下面保理模块
 * */
// 融资申请
import Step1_bl from '../components/applyLoan/Step1.vue';
import Step2_bl from '../components/applyLoan/Step2.vue';
import Step3_bak_bl from '../components/applyLoan/Step3_bak_bl.vue';
import Step3_bl from '../components/applyLoan/Step3.vue';
import Step4_bl from '../components/applyLoan/Step4.vue';
import Step5_bl from '../components/applyLoan/Step5.vue';
// 我的保理
import MyLoan_bl from '../components/personalCenter/MyLoan_bl.vue'; // 我的保理
import LoanLists_bl from '../components/personalCenter/LoanLists_bl.vue'; // 我的保理列表
import LoanDetail_bl from '../components/personalCenter/LoanDetail_bl.vue'; // 保理详情
import LoanDetail_bl_pool from '../components/personalCenter/LoanDetail_bl_pool.vue'; // 保理详情
import RepaymentInfo_bl from '../components/personalCenter/RepaymentInfo_bl.vue'; // 还款计划详情
import FrontVoucherInfo_bl from '../components/personalCenter/FrontVoucherInfo_bl.vue'; // 凭证列表--凭证详情接口

// 我的票据

import MyBill from '../components/personalCenter/MyBill.vue'; // 我的票据
import FrontVoucherInfo_pj from '../components/personalCenter/FrontVoucherInfo_pj.vue'; // 凭证列表--凭证详情
import MainProjectContractList from '../components/personalCenter/MainProjectContractList.vue'; // 保理主合同
Vue.use(Router);

// name不应重复，目前拿meta代替
const routes = [
  {
    path: '/',
    component: Index,
    meta: {
      name: 'index',
      requiresAuth: false
    }
  },
  {
    path: '/products/',
    component: Products,
    meta: {
      name: 'products',
      requiresAuth: false
    }
  },
  // {
  //   path: '/products/:categoryName/:customerType',
  //   component: Products,
  //   meta: {
  //     name: 'products',
  //     requiresAuth: false
  //   }
  // },
  //   {
  //       path: '/products/:categoryName',
  //       component: Products,
  //       meta: {
  //           name: 'products',
  //           requiresAuth: false
  //       }
  //   },
  {
    path: '/product/:id',
    component: ProductDetails,
    meta: {
      name: 'productDetails',
      requiresAuth: false
    }
  },
  {
    path: '/product',
    component: ProductDetails,
    meta: {
      name: 'productDetails',
      requiresAuth: false
    }
  },
  {
    path: '/user',
    component: User,
    redirect: '/login',
    meta: {
      name: 'user',
      requiresAuth: false
    },
    children: [
      {
        path: '/login',
        component: Login,
        meta: {
          name: 'login',
          requiresAuth: false
        }
      },
      {
        path: '/register',
        component: Register,
        meta: {
          name: 'register',
          requiresAuth: false
        }
      },
      {
        path: '/forgetPassword',
        component: ForgetPassword,
        meta: {
          name: 'forgetPassword',
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/applyLoan/:id',
    component: ApplyLoan,
    redirect: '/products',
    meta: {
      name: 'applyLoan',
      requiresAuth: true,
      keepAlive: true // 需要被缓存
    },
    children: [
      {
        path: 'step1_bl',
        name: 'step1_bl',
        component: Step1_bl,
        meta: {
          name: 'Step1_bl',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step1_xd',
        component: Step1_xd,
        meta: {
          name: 'Step1_xd',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step2_bl',
        name: 'step2_bl',
        component: Step2_bl,
        meta: {
          name: 'Step2_bl',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step2_xd',
        component: Step2_xd,
        meta: {
          name: 'Step2_xd',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step3_bl',
        name: 'step3_bl',
        component: Step3_bl,
        meta: {
          name: 'Step3_bl',
          requiresAuth: true,
          keepAlive: false // 不需要缓存
        }
      },
      {
        path: 'step3_xd',
        component: Step3_xd,
        meta: {
          name: 'Step3_xd',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step3_bak_bl',
        name: 'step3_bak_bl',
        component: Step3_bak_bl,
        meta: {
          name: 'Step3_bak_bl',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step4_bl',
        name: 'step4_bl',
        component: Step4_bl,
        meta: {
          name: 'Step4_bl',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step4_xd',
        component: Step4_xd,
        meta: {
          name: 'Step4_xd',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'step5_bl',
        name: 'step5_bl',
        component: Step5_bl,
        meta: {
          name: 'Step5_bl',
          requiresAuth: true,
          keepAlive: false // 需要被缓存
        }
      },
      {
        path: 'step5_xd',
        component: Step5_xd,
        meta: {
          name: 'Step5_xd',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      }
    ]
  },
  {
    path: '/personalCenter',
    component: PersonalCenter,
    meta: {
      name: 'personalCenter',
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: MyLoan,
        meta: {
          name: 'myLoan',
          requiresAuth: true
        },
        children: [
          {
            path: '',
            component: LoanLists,
            meta: {
              name: 'LoanLists',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'myLoan',
        component: MyLoan,
        meta: {
          name: 'myLoan',
          requiresAuth: true
        },
        children: [
          {
            path: '',
            component: LoanLists,
            meta: {
              name: 'LoanLists',
              requiresAuth: true
            }
          },
          {
            path: 'loanLists',
            component: LoanLists,
            meta: {
              name: 'LoanLists',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'myLoan_bl',
        component: MyLoan_bl,
        meta: {
          name: 'myLoan_bl',
          requiresAuth: true
        },
        children: [
          {
            path: '',
            component: LoanLists_bl,
            meta: {
              name: 'LoanLists_bl',
              requiresAuth: true
            }
          },
          {
            path: 'loanLists_bl',
            component: LoanLists_bl,
            meta: {
              name: 'LoanLists_bl',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'myBill',
        component: MyBill,
        meta: {
          name: 'MyBill',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: 'mainProjectContractList',
        component: MainProjectContractList,
        meta: {
          name: 'MainProjectContractList',
          requiresAuth: true,
          keepAlive: true // 需要被缓存
        }
      },
      {
        path: '/frontVoucherInfo_pj',
        component: FrontVoucherInfo_pj,
        meta: {
          name: 'FrontVoucherInfo_pj',
          requiresAuth: true
        }
      },
      {
        path: 'myInfo',
        component: MyInfo,
        meta: {
          name: 'myInfo',
          requiresAuth: true
        },
        children: [
          {
            path: '/personalCenter/myInfo/PersonInfo',
            component: PersonInfo,
            meta: {
              name: 'PersonInfo',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'bankcardInfo',
        component: BankcardInfo,
        meta: {
          name: 'bankcardInfo',
          requiresAuth: true
        }
      },
      {
        path: 'bankCardSign',
        name: 'bankCardSign',
        component: bankCardSign,
        meta: {
          name: 'bankcardInfo',
          requiresAuth: true
        }
      },
      {
        path: 'fileUploading',
        component: FileUploading,
        meta: {
          name: 'fileUploading',
          requiresAuth: true
        }
      },
      {
        path: 'realNameAuth',
        component: RealNameAuth,
        meta: {
          name: 'realNameAuth',
          requiresAuth: true
        }
      },
      {
        path: 'updatePassword',
        component: UpdatePassword,
        meta: {
          name: 'updatePassword',
          requiresAuth: true
        }
      },
      {
        path: '/repaymentInfo/:financePayPeriod/:financePayId/:repayStatusCode',
        component: RepaymentInfo,
        meta: {
          name: 'myLoan',
          requiresAuth: true
        }
      },
      {
        path: '/repaymentInfo_bl/:repayPeriod/:financePayId', // 我的保理列表--还款计划--还款详情
        component: RepaymentInfo_bl,
        meta: {
          name: 'myLoan_bl',
          requiresAuth: true
        }
      },
      {
        path: '/FrontVoucherInfo_bl/:frontApplyId/:voucherInfoId', // 我的保理列表--凭证详情列表----凭证详情
        component: FrontVoucherInfo_bl,
        meta: {
          name: 'myLoan_bl',
          requiresAuth: true
        }
      },
      {
        path: '/loanDetail/:frontApplyId',
        component: LoanDetail,
        meta: {
          name: 'myLoan',
          requiresAuth: true
        }
      },
      {
        path: '/loanDetail_bl/:frontApplyId',
        component: LoanDetail_bl,
        meta: {
          name: 'myLoan_bl',
          requiresAuth: true
        }
      },
      {
        path: '/loanDetail_bl_pool',
        component: LoanDetail_bl_pool,
        meta: {
          name: 'loanDetail_bl_pool',
          requiresAuth: true
        }
      },      
      {
        path: '/prepayment/:itemApplyId',
        component: Prepayment,
        meta: {
          name: 'myLoan',
          requiresAuth: true
        }
      },
      // 转让通知书列表
      {
        path: '/personalCenter/transferAdvice/list',
        component: TransferAdviceList,
        meta: {
          name: 'transferAdvice',
          requiresAuth: true
        }
      },
      // 转让通知书详情
      {
        path: '/personalCenter/transferAdvice/detail/:id',
        component: TransferAdviceDetail,
        meta: {
          name: 'transferAdvice',
          requiresAuth: true
        }
      },
      // 回购通知书列表
      {
        path: '/personalCenter/repoNotice/list',
        component: RepoNoticeList,
        meta: {
          name: 'repoNotice',
          requiresAuth: true
        }
      },
      // 回购通知书详情
      {
        path: '/personalCenter/repoNotice/detail/:id',
        component: RepoNoticeDetail,
        meta: {
          name: 'repoNotice',
          requiresAuth: true
        }
      },
      // 项目合同列表
      {
        path: '/personalCenter/projectContract/list',
        component: ProjectContractList,
        meta: {
          name: 'projectContract',
          requiresAuth: true
        }
      },
      // 主业务合同
      {
        path: '/personalCenter/blLoanContract/list',
        component: blLoanContractList,
        meta: {
          name: 'blLoanContract',
          requiresAuth: true
        }
      },
      {
        path: '/personalCenter/message',
        component: message,
        meta: {
          name: 'message',
          requiresAuth: true
        }
      },
      {
        path: '/personalCenter/messagedetails',
        component: messagedetails,
        meta: {
          name: 'messagedetails',
          requiresAuth: true
        }
      },
      {
        path: '/personalCenter/workOrder',
        component: workOrder,
        meta: {
          name: 'workOrder',
          requiresAuth: true
        }
      }
      ,
      {
        path: '/personalCenter/workOrderDetails',
        component: workOrderDetails,
        meta: {
          name: 'workOrderDetails',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/aboutUs',
    component: AboutUs,
    meta: {
      name: 'aboutUs',
      requiresAuth: false
    }
  },
  {
    path: '/factoring',
    name: 'factoring',
    component: Factoring,
    meta: {
      name: 'factoring',
      requiresAuth: false
    }
  },
  {
    path: '/bill',
    component: Bill,
    meta: {
      name: 'bill',
      requiresAuth: false
    }
  },
  {
    path: '/lease',
    component: Lease,
    meta: {
      name: 'lease',
      requiresAuth: false
    }
  }

];

const router = new Router({
  linkActiveClass: 'active',
  routes
});

router.beforeEach((to, from, next) => {
  if (
    _.isEmpty(
      JSON.parse(
        decodeURIComponent(
          !_.isUndefined(Cookie.get('userData')) ? Cookie.get('userData') : '{}'
        )
      )
    ) &&
    to.meta.requiresAuth
  ) {
    next({
      path: '/login'
    });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  placeholders.placeHolder(this);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js